module.exports = {"title":"Pricing","errorRequired":"This field is required.","errorInvalid":"The format is invalid.","table":{"titleName":"Name","titlePrice":"Price"},"helps":[{"title":"Tip","content":"<p>Examples: Adult, Senior, Student, Military, etc.</p>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/FlexpassPricing/locales/en.json
// module id = 1720
// module chunks = 0